import type { Verktoy } from '../types/minhelseentities';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import { erApenVerktoy, erVerktoyTilgjengelig } from './utils';

export const kanInnloggetBrukerSeAapneKnapp = (verktoy: Verktoy, erLaeringsaktivitet: boolean): boolean => {
  return (
    isAuthorized() &&
    erVerktoyTilgjengelig(verktoy) &&
    verktoy.KanStartesAvInnloggetBruker &&
    (erLaeringsaktivitet || !verktoy.Laeringsressurs.KreverForskrivning)
  );
};

export const kanAnonymBrukerSeAapneKnapp = (verktoy: Verktoy): boolean => {
  return !isAuthorized() && !verktoy.Laeringsressurs.KreverForskrivning && erVerktoyTilgjengelig(verktoy);
};

export const maaLoggeInnForAaAapneVerktoy = (verktoy: Verktoy): boolean => {
  return erApenVerktoy(verktoy.VerktoyKategori) ? false : true;
};
